import React, { ReactNode } from 'react';
import clsx from 'clsx';
import useStyles from '../styles';
import { InfoIcon } from '../../../../components/icon/solid';
import { CustomActionCell } from '../../../../components';

type Props = {
  text: string| ReactNode;
  infoBlock?: string;
  titleBlock?: boolean;
};

const PricingColumn = ({
  text,
  infoBlock = '',
  titleBlock = false,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.defaultColumn, {
      [classes.defaultColumnInfo]: infoBlock,
      [classes.defaultColumnTitle]: titleBlock,
    })}
    >
      <span className={classes.defaultColumnText}>{text}</span>
      {infoBlock
      && (
        <CustomActionCell
          title={<InfoIcon className={classes.icon} />}
          classNameButtonWrapper={classes.commentButtonWrapper}
          onMouse
        >
          <p className={classes.comment}>
            {infoBlock}
          </p>
        </CustomActionCell>
      )}
    </div>
  );
};

export default PricingColumn;
